import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';
import {UserpermissionService} from '../../services/userpermission.service';
import{ArticleService} from '../../services/article.service';
import {UserService} from '../../services/user.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-admin-user-profile',
  templateUrl: './admin-user-profile.component.html',
  styleUrls: ['./admin-user-profile.component.css']
})
export class AdminUserProfileComponent implements OnInit,IRule {

  @HostBinding('style.width') public width: string = '100%';

  userName='';
  navigationsType=[];
  notification:any=[];
  msg:any;
	toastr:any;
  _router:any;
  token:any='';
  per_page:number=10;
  loader_image:boolean =true
  name:any;
  email:any;
  selectedRole:Array<any> = [];
  selectedStatus:Array<any> = [];
  screenName:any;
  departmentList:any=[]
  dropdownSettings = {};
  dropdownSettings2 = {};
  statusList:Array<any>= [

    {key:'Active',value:'active'},
    {key:'Inactive',value:'inactive'},
     
    
  ];
  dataList:Array<any>= [];
  roleList:Array<any>= [];
  msgSubscribe:Subscription;
  userId:any;
  oldUserId:any;
  country:any;

  constructor(msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService,private userService:UserService,private userpermissionService:UserpermissionService) { 
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;

    this.msgSubscribe=   this.msg.getMessage().subscribe( (evt) => {
     
      if(evt!=undefined){

         
       switch(evt.text.type){
         
         case 'admin_user_edit':

         this.userId = evt.text.userId
         this.roleList = evt.text.roleList
         
         break;


       }

      }

   });

    
  }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: true,
      idField: 'key',
      textField: 'value',
      closeDropDownOnSelection:true
    }; 
    this.dropdownSettings2 = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      itemsShowLimit: 2,

      enableCheckAll:false
      //allowSearchFilter: true,
     // selectAllText: 'Select All',
     // unSelectAllText: 'UnSelect All'
    }; 

    try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        // limit:this.per_page,
        // 'page':'settings'
      }
      
      this.groupList(data);

      if(this.userId!=undefined){
       
        let data={
          token:this.token,
          id:this.userId,
          page:'users'
        }
      
        this.userService.getUserList(data).subscribe( (response)=>{
      
            if(response.status=='success'){
              
              if(response.users[0]!=undefined){
                this.name = response.users[0].name
                this.email = response.users[0].email
                this.screenName = response.users[0].department
                this.country = response.users[0].country
                this.selectedRole = this.roleList.filter( (roleI) => { return roleI.key == response.users[0].role[0]}); 
                this.selectedStatus = this.statusList.filter( (statusI) => { return statusI.key == response.users[0].status})
                
              }
              
 
            } else{

              this.toastr.error('User details not found. Please try again later', '', {timeOut: 3000});
            }
      
        });

      }else{
        this.toastr.warning('Please select a user', '', {timeOut: 3000});
        this.loader_image = false
        this._router.navigate(['/users']);
      }


    }catch(error){

      this._router.navigate(['/vlogin']);

    }
    
  }

  ngAfterViewInit(){
    $(document).ready(function(){ 
      $('input').blur(function(event) {
      var inputValue = this.value;
      if (inputValue) {
        this.classList.add('value-exists');
      } else {
        this.classList.remove('value-exists');
      }
      });
      });
  }
  ngOnDestroy() {

    this.msgSubscribe.unsubscribe();
	  

  } 

  groupList(data){

    this.articleService.getUserGroup(data).subscribe( (res)=>{

      if(res.status=='success'){
        
       this.loader_image =false
        this.userName=res.user.name;

        this.navigationsType=res.navigation;

        this.notification =res.notification;

        this.broadcast_menu();
        
        this.departmentList=res.department;

       

      }else{        
        this.toastr.error(res.message, '', {timeOut: 3000});
      }
    });

  }

  onStatusSelect(item: any){

    
  }

  onRoleSelect(item: any) {

   
  }

  onRoleSelectAll(item: any){
   
  }


  onRoleDeSelect(item: any){

    
  }

  onRoleDeSelectAll(item: any){
   
  } 

  updateProfile(){
    let role =[];
    this.selectedRole.map((x)=>{
       role.push(x.key)
    })

    
    
    let data={
      token:this.token,
      id:this.userId,
      name: this.name,
      role:role,
      country:this.country,
      department:this.screenName,
      page:'users'
    }

    if(this.selectedStatus[0].key=='Inactive'){
      data['inactive']= true
    }else{
      data['active']= true
    }
  
    this.userService.getUserList(data).subscribe( (response)=>{
  
        if(response.status=='success'){
          
          this.toastr.success('User updated successfully', '', {timeOut: 3000});
          this._router.navigate(['/users']);

        } else{

          this.toastr.error('User updation failed. Please try again later', '', {timeOut: 3000});
        }
  
    });
   
  }

  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   } 

}
